import { Controller } from "@hotwired/stimulus"

const NO_SEATS_MESSAGE = "No seats left. Please add seats or remove users to invite additional users."

export default class extends Controller {
  static get targets() { return ["email", "warning"]; }
  static get values() { return { availableSeats: Number }; }

  // An organization on an unlimited-users plan renders no seat count at all, and every
  // comparison against NaN is false — which is what keeps the warning off those pages.
  get availableSeats() {
    return this.hasAvailableSeatsValue ? this.availableSeatsValue : NaN;
  }

  warnWhenFull() {
    if (this.availableSeats !== 0) { return; }

    this.showWarning();
  }

  syncWarning() {
    if (this.availableSeats === 0) { return; }

    if (this.emailCount() > this.availableSeats) {
      this.showWarning();
    } else {
      this.warningTarget.style.display = "none";
    }
  }

  emailCount() { return this.emailTarget.value.split(",").length; }

  showWarning() {
    // NO_SEATS_MESSAGE is a plain-text constant, never markup, so textContent is enough.
    this.warningTarget.textContent = NO_SEATS_MESSAGE;
    this.warningTarget.style.display = "";
  }
}
